<template>
  <el-form :model="form" :rules="rules" ref="form" label-width="60px">
    <el-form-item :label="$t('text.email')" prop="Email">
      <el-input v-model="form.Email" :placeholder="$t('text.email')"></el-input>
    </el-form-item>
    <el-form-item :label="$t('text.role')" prop="RoleId">
      <el-select
        v-model="form.RoleId"
        :placeholder="$t('text.select')"
        :loading="loading"
        class="wp-100"
      >
        <el-option
          v-for="item in roleOptions"
          :key="item.Id"
          :label="item.RoleName"
          :value="item.Id"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-button
        class="common-btn"
        :loading="sendLoading"
        @click="submit()"
        v-if="p('Manage Module.Users.Invite User.Save')"
        >{{ $t('text.send_invitation').toUpperCase() }}</el-button
      >
    </el-form-item>
  </el-form>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
export default {
  data() {
    return {
      loading: false,
      sendLoading: false,
      roleOptions: [],
      form: {
        Email: '',
        RoleId: ''
      },
      rules: {
        Email: [
          {
            required: true,
            message: this.$t('text.please_enter_email_address'),
            trigger: 'blur'
          },
          {
            type: 'email',
            message: this.$t('text.please_enter_the_correct_email_address'),
            trigger: ['blur', 'change']
          }
        ],
        RoleId: [
          {
            required: true,
            message: this.$t('text.please_assign_a_role_to_the_user'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted() {
    this.getRoles()
  },
  methods: {
    getRoles() {
      this.roleOptions = []
      this.loading = true
      ApiService.GetRoles(this.$store.getters[`user/selecteOrganisationId`])
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.roleOptions = response.data.data.filter(
              item => item.RoleName !== 'SuperAdmin'
            )
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.sendInvitation()
        }
      })
    },
    sendInvitation() {
      this.sendLoading = true
      ApiService.InviteUser({
        ...this.form,
        OrganisationId: this.$store.getters[`user/selecteOrganisationId`],
        Floors: [],
        DomainUrl: document.location.origin
      })
        .then(response => {
          this.sendLoading = false
          if (response.data.success) {
            swal({
              icon: 'success',
              timer: 2000,
              title: this.$t('text.invitation_email_sent')
            })
            this.$refs.form.resetFields()
            this.$emit('sendSuccessfully')
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.sendLoading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    }
  }
}
</script>
